<template>
  <v-select
    :items="finishes"
    item-value="key"
    item-text="name"
    label="Настройки подсветки"
    dense
    hide-details
    outlined
    :menu-props="{
      bottom: true,
      offsetY: true,
      transition: 'scale-transition',
    }"
    single-line
    class="py-2 px-0"
    @change="changed"
    v-model="selected"
  >
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selected: [],
      finishes: [
        { key: "", name: "" },
        { key: "one_view", name: "1й р" },
        { key: "two_view", name: "2й р" },
        { key: "three_view", name: "3й р" },
        { key: "four_view", name: "4й р" },
        { key: "five_view", name: "5й р" },
        { key: "six_view", name: "6й р" },
        { key: "seven_view", name: "7й р" },
        { key: "eight_view", name: "8й р" },
        { key: "nine_view", name: "9й р" },
      ],
    };
  },
  methods: {
    ...mapActions(["addHighlight"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      // console.log("Changed:" + this.selected);
      this.addHighlight({ type: "winner_coefs", value: this.selected });
    },
  },

  created() {
    let settings = this.getSettings().highlights;
    if (settings.winner_coefs == "") {
      return;
    }
    let value = settings.winner_coefs;
    // console.log("VALUE: " + value);
    for (const item of this.finishes) {
      if (item.key == value) this.selected = value;
    }
  },
};
</script>

<style scoped></style>
